import apiClient from './client'

/** Metadados de uma chave do cofre (a API nunca devolve o valor aqui). */
export interface CofreChave {
  chave: string
  categoria?: string | null
  descricao?: string | null
  tenant_id?: number | null
  sensivel: boolean
  updated_at?: string | null
  updated_by?: number | null
}

export interface CofreChaveUpsert {
  valor: Record<string, unknown>
  categoria?: string | null
  descricao?: string | null
  tenant_id?: number | null
}

export const cofreApi = {
  list: async (params?: { categoria?: string; tenant_id?: number }): Promise<CofreChave[]> => {
    const response = await apiClient.get<CofreChave[]>('/cofre', { params })
    return response.data
  },

  get: async (chave: string): Promise<CofreChave> => {
    const response = await apiClient.get<CofreChave>(`/cofre/${encodeURIComponent(chave)}`)
    return response.data
  },

  save: async (chave: string, data: CofreChaveUpsert): Promise<CofreChave> => {
    const response = await apiClient.put<CofreChave>(`/cofre/${encodeURIComponent(chave)}`, data)
    return response.data
  },

  remove: async (chave: string): Promise<void> => {
    await apiClient.delete(`/cofre/${encodeURIComponent(chave)}`)
  },

  /** Revela o valor em claro — operação auditada no backend. */
  reveal: async (chave: string): Promise<Record<string, unknown>> => {
    const response = await apiClient.post<{ chave: string; valor: Record<string, unknown> }>(
      `/cofre/${encodeURIComponent(chave)}/revelar`
    )
    return response.data.valor
  },
}
